import Term from 'components/common/TermToggle';
import Explanation from 'components/custom/TermExplanation';
import * as React from 'react';
export default {
  Term,
  Explanation,
  React
};